import { fancybox } from "@fancyapps/fancybox";

//
// CONFIG
$.fancybox.defaults.transitionEffect = ["tube"];
$.fancybox.defaults.buttons          = ["zoom", "slideShow", "fullScreen", "thumbs", "close"];
$.fancybox.defaults.protect          = true;